import setNestedValue from '@/services/functions/setNestedValue'
function recalculate (dataItem, hasEquivalenceSurcharge, hasOperationType) {
  calculateSubTotal(dataItem)
  calculateTotal(dataItem)
  calculateCuotaRecargo(dataItem, dataItem.Taxes[0].EquivalenceSurcharge, hasEquivalenceSurcharge)
  calculateTotalConImpuesto(dataItem, hasEquivalenceSurcharge, hasOperationType)
}
function calculateSubTotal (dataItem, cantidad = dataItem.cantidad) {
  if (isNotFalsy(cantidad)) {
    const subtotal = dataItem.UnitPriceWithoutTax * cantidad
    setNestedValue('subtotal', dataItem, subtotal, true)
  } else {
    setNestedValue('subtotal', dataItem, '', true)
  }
}
function calculateTotal (dataItem) {
  if (isNotFalsy(dataItem.subtotal) && dataItem.descuentos[0].incluyeDescuento !== null) {
    const total = (dataItem.subtotal - (dataItem.descuentos[0].cuota || 0))
    setNestedValue('total', dataItem, total, true)
  } else {
    setNestedValue('total', dataItem, '', true)
  }
}
function calculateCuotaRecargo (dataItem, recargo, hasEquivalenceSurcharge) {
  if (hasEquivalenceSurcharge) {
    const cuotaRecargo = (recargo !== 0 || recargo !== '0') ? dataItem?.total * recargo / 100 :'' 
    setNestedValue('cuotaRecargo', dataItem, cuotaRecargo, true)
  } else {
    setNestedValue('cuotaRecargo', dataItem, 0, true)
  }
}
function calculateTotalConImpuesto (dataItem, hasEquivalenceSurcharge, hasOperationType) {
  if (isNotFalsy(dataItem.total) && isNotFalsy(dataItem.Taxes)) {
    const total = dataItem.total || 0
    dataItem.Taxes.forEach(tax => 
      setNestedValue('cuota', tax, total * (tax.TaxRate || 0) / 100, true) &&
        setNestedValue('cuotaRecargo', tax, hasEquivalenceSurcharge ? (total * (tax.EquivalenceSurcharge || 0) / 100) : 0, true)
    )
    const { cuotaImpuesto, cuotaRecargo } = dataItem.Taxes.reduce(
      (acc, x) => ({ cuotaImpuesto: acc.cuotaImpuesto + x.cuota, cuotaRecargo: acc.cuotaRecargo + x.cuotaRecargo }), 
      { cuotaImpuesto: 0, cuotaRecargo: 0 }
    )
    const totalConImpuesto = hasOperationType ? total : total + cuotaImpuesto + (hasEquivalenceSurcharge ? cuotaRecargo : 0)
    setNestedValue('totalConImpuesto', dataItem, totalConImpuesto, true)
  } else {
    setNestedValue('totalConImpuesto', dataItem, '', true)
  }
}
function isNotFalsy (value) {
  if (Array.isArray(value)) {
    return value.length && value.every(isNotFalsy)
  }
  return ![undefined, null, false, ''].includes(value)
}

export default { recalculate, calculateSubTotal, calculateTotal, calculateCuotaRecargo, calculateTotalConImpuesto }
export { recalculate, calculateSubTotal, calculateTotal, calculateCuotaRecargo, calculateTotalConImpuesto }
